import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { addressesTypes } from 'actions/types'

const initialState = []
const baseType = addressesTypes.FETCH_ORGANISATION_ADDRESSES

const reducer = combineReducers({
  requestState: requestStateReducer(baseType),
  data: dataReducer({ initialState, baseType }),
})

export default reducer
